// Mock data for CNP CPA website (clone based on D & PARTNERS CPA structure)

export const firm = {
  name: "CNP CPA",
  fullName: "CNP CPA",
  tagline:
    "We specialize in tax advisory, planning and accounting services, providing significant value-add to our clients' most complex business problems.",
};

export const navItems = [
  { label: "About Us", path: "/about-us" },
  { label: "Our Team", path: "/our-team" },
  { label: "Our Services", path: "/our-services" },
  { label: "Join Us", path: "/join-us" },
  { label: "Contact Us", path: "/contact-us" },
];

export const languages = ["EN", "繁體", "简体"];

export const logoUrl =
  "https://customer-assets-jt897jd0.emergentagent.net/job_accounting-firm-hub-2/artifacts/b5t7n8su_Image%205-10-2026%20at%205.55%E2%80%AFPM.webp";


// Hero + interior page banner (Hong Kong themed)
export const heroDesk =
  "https://images.unsplash.com/photo-1536599018102-9f803c140fc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const pageBanner =
  "https://images.unsplash.com/photo-1620015092538-e33c665fc181?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const heroServices = {
  title: "Our Professional Services",
  bullets: ["Tax advisory & planning", "Accounting services"],
};

export const aboutImages = {
  primary:
    "https://images.unsplash.com/photo-1638205022792-85c33651ae2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  vision:
    "https://images.unsplash.com/photo-1532455935509-eb76842cee50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const aboutContent = {
  intro:
    "CNP CPA specializes in tax advisory, tax planning and accounting services. We focus on providing significant value-add to our clients' most complex business problems.",
  body:
    "We apply a pan-Asia strategic mindset in expanding and strengthening our presence within this fast-growing region. Through our affiliates over the Mainland China and Asia-Pacific Region, we draw upon a wide pool of resources and expertise to deliver professional services through multi-lingual teams experienced in both local and international requirements and regulations.",
  credentials: [
    "A CPA firm registered and practising under the Hong Kong Institute of Certified Public Accountants and the Accounting and Financial Reporting Council",
    "A PIE auditor registered under the Accounting and Financial Reporting Council",
    "A member of Guangdong-Hong Kong-Macao audit firms federation",
  ],
  visionTitle: "We grow, and so do you!",
  visionSub: "— always create values to everyone professionally",
  visionBody: [
    "Our culture is one of reliability and trustworthiness; you can be sure of our confidentiality so that you can be frank and open. Our demand for high professional standards is second to none, our staff are our asset and we ensure they have the right quality to serve our clients. We assign high value to integrity and have ambitious visions to grow and improve.",
    "As a professional services organization, we have a duty to ensure that our clients' businesses operate to the highest standards, meeting all necessary local and international requirements. With our local expertise and global knowledge providing a clear vision of the path ahead, our clients will benefit from CNP CPA's cross-cultural perspective to enjoy cross-border business success.",
    "Our vision is to exceed our client's expectations and establish a leading service provider in business. We provide a wide range of services to suit your needs.",
    "Our knowledge and the rich experience of our team allow us to offer services tailored to the stage of development and the individual needs of each client.",
  ],
};

export const stats = [
  { value: "20+", label: "Years of Experience" },
  { value: "500+", label: "Clients Served" },
  { value: "50+", label: "Listed Companies" },
  { value: "3", label: "Regional Offices" },
];

export const services = [
  {
    id: "tax",
    title: "Tax Advisory & Planning",
    short:
      "We help individuals and businesses stay compliant while structuring their affairs tax-efficiently across Hong Kong, Mainland China and beyond.",
    image:
      "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxmaW5hbmNlJTIwYXVkaXR8ZW58MHx8fHwxNzkwNjY5NDgyfDA&ixlib=rb-4.1.0&q=85",
    points: [
      "Profits tax, salaries tax & property tax compliance",
      "Tax planning & group structuring",
      "Cross-border & international tax advisory",
      "Transfer pricing documentation",
      "IRD correspondence & tax dispute resolution",
      "Tax due diligence for transactions",
    ],
    details: [
      "Our tax team keeps abreast of the latest Hong Kong and international tax developments to help you navigate an increasingly complex regulatory landscape.",
      "We take time to understand your business and personal circumstances, then design practical, tax-efficient strategies that mitigate risk and support your long-term goals.",
      "From routine filing to complex planning and handling enquiries from the Inland Revenue Department, we provide clear, actionable advice at every stage.",
    ],
  },
  {
    id: "accounting",
    title: "Accounting Services",
    short:
      "We provide reliable, accurate and timely accounting support so you can focus on running and growing your business with confidence.",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    points: [
      "Bookkeeping & management accounts",
      "Preparation of financial statements",
      "Payroll processing & MPF administration",
      "Accounts payable & receivable management",
      "Accounting system setup & clean-up",
      "Company secretarial support",
    ],
    details: [
      "Whether you need full outsourced bookkeeping or periodic management accounts, our team delivers organised, up-to-date records that stand up to audit and scrutiny.",
      "We tailor our accounting services to the stage of development and individual needs of each client, scaling with you as your business grows.",
      "With accurate financial information at your fingertips, you can make better decisions, meet statutory deadlines and keep stakeholders informed.",
    ],
  },
];

export const teamGroupPhoto =
  "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const teamMembers = [
  {
    id: 1,
    name: "Anntice Lai",
    title: "Managing Director & Head of Technical and Regulatory",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDY2OTUyMXww&ixlib=rb-4.1.0&q=85",
    bio: [
      "Ms. Lai has over 20 years in the auditing and technical field. She developed in-depth knowledge in ethical and AML/CTF compliance, auditing, financial reporting and listings, and a profound understanding of the Hong Kong regulatory environment.",
      "She is experienced in resolving and advising complex group structuring, technical accounting, auditing, listing and compliance matters for SMEs to listed entities, both local and overseas.",
      "She actively involves in providing comments on standards setting by participating in various relevant committees and panels.",
    ],
    certs: ["CPA (Practising)"],
  },
  {
    id: 2,
    name: "Danny Heung",
    title: "Director & Head of Audit",
    image:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDY2OTUyMXww&ixlib=rb-4.1.0&q=85",
    bio: [
      "Mr. Heung has over 18 years of experience in auditing and business advisory in finance and accounting, merger and acquisition and IPO preparation.",
      "He has served numerous engagements for a wide range of listed companies, multinational corporations and private groups, including property development, manufacturing and trading, retail, construction and biological assets industry.",
      "He has actively involved in IPO projects and has robust understanding of Hong Kong listing rules and requirements.",
    ],
    certs: [
      "CPA (Practising)",
      "Ordinary Member of The Society of Chinese Accountants & Auditors (MSCA)",
    ],
  },
  {
    id: 3,
    name: "Anderson Wong",
    title: "Director",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDY2OTUyMXww&ixlib=rb-4.1.0&q=85",
    bio: [
      "Mr. Wong has over 10 years' experience in accounting, advisory, auditing and IPO preparation for Hong Kong listed companies and private companies. His prior experience with one of the Big-4 firms enhanced his professional knowledge in dealing with over a hundred audit and assurance projects for companies of different scale and size.",
      "He has extensive experience in dealing with clients in food and beverage, new energy and construction industries.",
      "Currently, his team is providing audit service to Cayman Fund clients.",
    ],
    certs: ["CPA (Practising)"],
  },
  {
    id: 4,
    name: "Billy Lee",
    title: "Director",
    image:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBoZWFkc2hvdHxlbnwwfHx8fDE3OTA2Njk1MjF8MA&ixlib=rb-4.1.0&q=85",
    bio: [
      "Mr. Lee has extensive experience in accounting and auditing. Before joining our firm, he worked in an international accounting firm providing assurance services to Hong Kong listed companies.",
      "He is now focusing on providing audit services for SME clients in all industries, including TVP and BUD funding applicants.",
      "He is good at providing instant solutions for his clients.",
    ],
    certs: ["CPA (Practising)"],
  },
  {
    id: 5,
    name: "Chalky Chiu",
    title: "Client Service Leader",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDY2OTUyMXww&ixlib=rb-4.1.0&q=85",
    bio: [
      "Mr. Chiu has over 10 years' experience in provision of auditing service for Hong Kong listed companies as well as small to large entities located in HK and PRC.",
      "His client portfolio ranges widely to cover aircraft leasing, property development, trading, retail and manufacturing, logistics, clinic organizations, education institutions, food and beverage production, film production and distribution, licensed corporations, solicitors, insurance brokers, money lending business, non-profit organizations and financial services.",
      "He is good at developing audit strategy for different scales and types of entities, and providing flexible solutions for business owners.",
    ],
    certs: ["CPA (Practising)"],
  },
  {
    id: 6,
    name: "Simeon Lau",
    title: "Director",
    image:
      "https://images.unsplash.com/photo-1685760259914-ee8d2c92d2e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBoZWFkc2hvdHxlbnwwfHx8fDE3OTA2Njk1MjF8MA&ixlib=rb-4.1.0&q=85",
    bio: [
      "Mr. Lau started his career at one of the Big-4 audit firms, and subsequently gained over 10 years' experience in dealing with private companies, MNCs and listed companies.",
      "He has served a wide range of clients in different industries such as logistics, construction, manufacturing, medical, retail, electronic products and licensed corporations regulated by the Hong Kong Securities and Futures Commission.",
      "He is currently taking part in US IPO projects by liaising with different professional parties overseas, and in assurance engagements related to sustainability.",
    ],
    certs: [
      "CPA (Practising)",
      "Associate of Chartered Management Accountant",
      "Associate of Hong Kong Chartered Governance Institute",
    ],
  },
];

export const listedClients = [
  { name: "Cornerstone", year: "2024" },
  { name: "KOS Holdings", year: "2024" },
  { name: "MediNet Group", year: "2025" },
  { name: "Tongda Industrial", year: "2024" },
  { name: "Man Shun Group", year: "2024" },
  { name: "Sky Light", year: "2024" },
  { name: "Luk Hing", year: "2024" },
  { name: "Top Standard", year: "2024" },
  { name: "Tungtex Holdings", year: "2025" },
];

export const offices = [
  {
    mapQuery: "Valley Centre, 80-82 Morrison Hill Road, Wan Chai, Hong Kong",
  },
  {
    mapQuery: "9 Chong Yip Street, Kwun Tong, Kowloon, Hong Kong",
  },
];

export const careers = {
  intro:
    "At CNP CPA, our people are our greatest asset. We are always looking for talented, driven professionals who share our commitment to integrity and excellence. Grow your career with a firm that invests in you.",
  benefits: [
    { title: "Professional Growth", text: "Structured training, mentorship and clear promotion pathways." },
    { title: "Diverse Exposure", text: "Work with listed companies, MNCs and SMEs across industries." },
    { title: "Work-Life Balance", text: "A supportive culture that values your wellbeing." },
    { title: "Global Perspective", text: "Cross-border engagements across Hong Kong, China and Asia-Pacific." },
  ],
  openings: [
    { title: "Audit Manager", type: "Full-time", location: "Hong Kong", exp: "6+ years" },
    { title: "Senior Audit Associate", type: "Full-time", location: "Hong Kong", exp: "3-5 years" },
    { title: "Audit Associate", type: "Full-time", location: "Hong Kong", exp: "0-2 years" },
    { title: "Assurance Consultant", type: "Full-time", location: "GuangZhou", exp: "3+ years" },
  ],
};
